const LOCAL_EXTERNAL_REFERENCE = 'dbdev'

const isLocalHostname = (hostname: string): boolean =>
  hostname === 'localhost' || hostname === '127.0.0.1'

/**
 * Extracts the subdomain from a URL
 * @param url - The full URL (e.g., "https://dbdev.realize.pro.br/api")
 * @returns The subdomain (e.g., "dbdev") or empty string if extraction fails.
 *          Localhost / 127.0.0.1 always resolve to "dbdev" for local development.
 * @example
 * getExternalReference("https://dbdev.realize.pro.br/api") // Returns "dbdev"
 * getExternalReference("https://prod.realize.pro.br") // Returns "prod"
 * getExternalReference("http://localhost:3333/api") // Returns "dbdev"
 */
export const getExternalReference = (url: string): string => {
  try {
    if (!url || typeof url !== 'string') {
      return ''
    }

    const urlObject = new URL(url)
    const hostname = urlObject.hostname

    if (isLocalHostname(hostname)) {
      return LOCAL_EXTERNAL_REFERENCE
    }

    const parts = hostname.split('.')

    if (parts.length < 2) {
      return ''
    }

    const subdomain = parts[0]

    if (!subdomain || subdomain === 'www') {
      return ''
    }

    return subdomain
  } catch (error) {
    console.error('Error parsing URL:', error)
    return ''
  }
}
